import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function PublicFooter() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo-fundo-branco.png" alt="Caixa Fácil Já" className="h-8 w-auto" />
            <span className="font-semibold text-white">Caixa Fácil Já</span>
          </div>
          <p className="text-sm">Gestão de caixa simplificada para pequenos e médios negócios. Registre vendas, despesas e veja o saldo em um só lugar.</p>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-3">Navegação</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/#inicio" className="hover:text-white">Início</a></li>
            <li><a href="/#recursos" className="hover:text-white">Recursos</a></li>
            <li><a href="/#gestao-caixa" className="hover:text-white">Gestão de Caixa</a></li>
            <li><a href="/#gestao-negocio" className="hover:text-white">Gestão do Negócio</a></li>
            <li><a href="/#controles-avancados" className="hover:text-white">Controles Avançados</a></li>
            <li><a href="/#planos" className="hover:text-white">Planos</a></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-3">Políticas</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/politica-de-privacidade" className="hover:text-white">Política de Privacidade</a></li>
            <li><a href="/politica-de-privacidade-ia" className="hover:text-white">Política de Privacidade de IA/ML</a></li>
          </ul>
          <h3 className="text-white font-semibold mt-6 mb-3">Conta</h3>
          <ul className="space-y-2 text-sm">
            <li><a href="/auth" className="hover:text-white">Entrar</a></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-3">Assine novidades</h3>
          <p className="text-sm mb-3">Receba dicas e atualizações do produto por e‑mail.</p>
          <div className="flex gap-2">
            <Input placeholder="seu@email.com" className="bg-slate-800 border-slate-700" />
            <Button>Assinar</Button>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <span className="text-xs">© {new Date().getFullYear()} Caixa Fácil Já</span>
          <div className="flex gap-4 text-xs">
            <a href="/#depoimentos" className="hover:text-white">O que dizem</a>
            <a href="/#cta" className="hover:text-white">Começar agora</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
